import React from 'react'
import { useParams } from 'react-router-dom'

import ViewCustomer from '@components/customers/ViewCustomer'

export default function ViewCustomerPage () {
  const { customerId } = useParams<any>()

  return (
    <div className="ViewCustomerPage">
      <h1 className="u-heading">Просмотр покупателя №{customerId}</h1>
      <ViewCustomer customerId={customerId} />
    </div>
  )
}
